import useEnv from '@shared/useEnv';
import Url from 'url-parse';

const useAssetPath = () => {
  const { assetHost } = useEnv();

  return (path: string): string => {
    if (!assetHost) return path;

    const url = new Url(assetHost);
    url.set('pathname', path);

    return url.toString();
  };
};

export default useAssetPath;
